/* eslint-disable no-magic-numbers */

const sortAsc = (list, key) => {
    const compareAscName = (a, b, compareKey = key) => {
        if (a[compareKey] < b[compareKey]) {
            return -1;
        }
        if (a[compareKey] > b[compareKey]) {
            return 1;
        }
        return 0;
    };

    return list.sort(compareAscName);
};

const sortDesc = (list, key) => {
    const compareDescName = (a, b, compareKey = key) => {
        if (a[compareKey] > b[compareKey]) {
            return -1;
        }
        if (a[compareKey] < b[compareKey]) {
            return 1;
        }
        return 0;
    };

    return list.sort(compareDescName);
};

export {
    sortAsc,
    sortDesc,
};
